import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, LeafIcon, SparkleIcon } from './Icons';
export function RevelationSection() {
  return <section className="relative w-full py-20 sm:py-28 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0f0a 0%, #111a11 30%, #162014 60%, #111a11 100%)'
  }} aria-label="The solution" data-id="element-284">
      {/* Subtle decorative line */}
      <div className="max-w-24 mx-auto mb-16 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" aria-hidden="true" data-id="element-285" />

      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-286">
        {/* Opening question */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-287">
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream leading-relaxed" data-id="element-288">
            What if I told you that adding just a few specific, cheap
            ingredients from your local grocery store could{' '}
            <span className="text-gold font-semibold" data-id="element-289">
              neutralize the inflammation
            </span>{' '}
            killing your dog?
          </p>
        </motion.div>

        {/* The "No" statements */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="space-y-5 mb-16" data-id="element-290">
          <div className="flex items-center gap-4" data-id="element-291">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency-red/20 flex items-center justify-center" data-id="element-292">
              <XIcon className="w-4 h-4 text-urgency-red-bright" data-id="element-293" />
            </div>
            <p className="font-sans text-base sm:text-lg text-cream-muted" data-id="element-294">
              No $400/month subscription boxes.
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-295">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency-red/20 flex items-center justify-center" data-id="element-296">
              <XIcon className="w-4 h-4 text-urgency-red-bright" data-id="element-297" />
            </div>
            <p className="font-sans text-base sm:text-lg text-cream-muted" data-id="element-298">
              No complicated kitchen science.
            </p>
          </div>
        </motion.div>

        {/* The positive — Hybrid Bowl Method */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative py-10 px-6 sm:px-10 bg-bg-card/60 border border-green-deep/40 rounded-xl" data-id="element-299">
          <div className="flex items-start gap-4" data-id="element-300">
            <div className="flex-shrink-0 mt-1" data-id="element-301">
              <LeafIcon className="w-7 h-7 text-green-accent" data-id="element-302" />
            </div>
            <div data-id="element-303">
              <p className="font-sans text-lg sm:text-xl text-cream leading-relaxed" data-id="element-304">
                Just{' '}
                <span className="font-semibold text-cream" data-id="element-305">
                  15 minutes a week
                </span>{' '}
                and the
              </p>
              <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-gold mt-2 flex items-center gap-3" data-id="element-306">
                <SparkleIcon className="w-5 h-5 text-gold/60 flex-shrink-0" data-id="element-307" />
                Hybrid Bowl Method
                <SparkleIcon className="w-5 h-5 text-gold/60 flex-shrink-0" data-id="element-308" />
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}